import { Box, MenuItem } from '@mui/material';
import { DocumentDataExclusionReasons } from '../../types/packager-types';
import {
  DocumentDataExclusionReasonDescriptions,
  formatExclusionReason,
} from '../../types/packager-enum-descriptions';

/**
 * Reasons the system owns. CONCATENATED is written only by the split flow, alongside the
 * SPLIT relationships that make the parent a recognized lineage parent, so hand-setting it
 * produces a row that looks split but has no children: the split caution exempts it and the
 * already-split banner has nothing to show, leaving no warning at all.
 */
export const SYSTEM_OWNED_EXCLUSION_REASONS: DocumentDataExclusionReasons[] = [
  DocumentDataExclusionReasons.CONCATENATED,
];

/**
 * True when a row's CURRENT reason must not be overwritten. Withholding a reason from the
 * dropdown stops it being SET; it says nothing about rows that already hold it, and a bulk
 * write applies one reason to every selected row.
 */
export const isSystemOwnedExclusionReason = (reason: string | null | undefined): boolean =>
  !!reason && SYSTEM_OWNED_EXCLUSION_REASONS.includes(reason as DocumentDataExclusionReasons);

export const renderExclusionReasonMenuItems = ({
  omit = [],
}: { omit?: DocumentDataExclusionReasons[] } = {}) =>
  Object.values(DocumentDataExclusionReasons)
    .filter((r) => !omit.includes(r))
    .map((r) => (
      <MenuItem key={r} value={r}>
        <Box sx={{ display: 'flex', flexDirection: 'column', py: 0.25, lineHeight: 1.25 }}>
          <Box component="span" sx={{ lineHeight: 1.25 }}>
            {formatExclusionReason(r)}
          </Box>
          <Box
            component="span"
            sx={{
              fontSize: '0.75rem',
              color: 'text.secondary',
              whiteSpace: 'normal',
              lineHeight: 1.25,
            }}
          >
            {DocumentDataExclusionReasonDescriptions[r]}
          </Box>
        </Box>
      </MenuItem>
    ));
